import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { adminAgentsAPI } from '../../../../services/api';

export default function DataSchemaNode({ data, selected }) {
  const { agentName } = useParams();
  const [fields, setFields] = useState(data?.fields?.length ? data.fields : null);
  const mountedRef = useRef(true);

  useEffect(() => {
    // If fields are already in node data, use them without fetching.
    if (data?.fields?.length) {
      setFields(data.fields);
      return;
    }
    mountedRef.current = true;
    adminAgentsAPI.listAgents().then((agents) => {
      const found = (agents || []).find((a) => a.name === agentName);
      if (mountedRef.current) setFields(found?.initial_data_schema || []);
    }).catch(() => {
      if (mountedRef.current) setFields([]);
    });
    return () => { mountedRef.current = false; };
  }, [agentName, data?.fields]);

  return (
    <Box sx={{ border: `2px solid ${selected ? '#5aaa7a' : '#3a8a5a'}`, borderRadius: 2, minWidth: 170, bgcolor: 'background.paper', boxShadow: selected ? '0 0 0 3px rgba(90,170,122,0.15)' : 1, overflow: 'hidden' }}>
      <Box sx={{ px: 1.5, py: 0.75, bgcolor: '#0e2a1a', display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography sx={{ color: '#7ae0a0', fontSize: 14 }}>⊞</Typography>
        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#a0f0c0', fontSize: 11 }}>Data Schema</Typography>
      </Box>
      <Box sx={{ px: 1.5, py: 0.75 }}>
        {fields === null && <Typography variant="caption" sx={{ color: 'text.disabled', fontSize: 9, fontStyle: 'italic' }}>Loading…</Typography>}
        {fields !== null && fields.slice(0, 4).map((f) => (
          <Box key={f.name} sx={{ display: 'flex', gap: 0.5 }}>
            <Typography variant="caption" sx={{ color: '#709080', fontSize: 9 }}>● {f.name}</Typography>
            <Typography variant="caption" sx={{ color: '#50a070', fontSize: 9 }}>{f.type}</Typography>
          </Box>
        ))}
        {fields !== null && fields.length > 4 && <Typography variant="caption" sx={{ color: 'text.disabled', fontSize: 9 }}>+{fields.length - 4} more</Typography>}
        {fields !== null && fields.length === 0 && <Typography variant="caption" sx={{ color: 'text.disabled', fontSize: 9, fontStyle: 'italic' }}>No fields defined</Typography>}
      </Box>
    </Box>
  );
}
